// src/utils/chartConfig.js
import { Chart } from 'chart.js';

export const initChartDefaults = () => {
  // Helper to get CSS variable values safely
  const getStyle = (variable, fallback) => {
    if (typeof document === 'undefined') return fallback;
    return getComputedStyle(document.documentElement).getPropertyValue(variable).trim() || fallback;
  };

  // 1. Set Font Family (matches Tailwind defaults)
  Chart.defaults.font.family = "'Inter', system-ui, -apple-system, sans-serif";
  Chart.defaults.font.size = 12;

  // 2. Set Global Text Color (using a CSS variable you likely have, or a hardcoded Tailwind gray)
  // We use a function here so it re-evaluates if needed, though defaults are usually static
  Chart.defaults.color = getStyle('--text-muted', '#6b7280'); // Tailwind gray-500
  Chart.defaults.scale.grid.color = getStyle('--border-color', '#e5e7eb'); // Tailwind gray-200
  
  // 4. Responsive Defaults
  Chart.defaults.responsive = true;
  Chart.defaults.maintainAspectRatio = false;
};